import React from "react";

function ChevronDownIcon({ fill = "#1F8268" }) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="17"
			height="16"
			fill="none"
			viewBox="0 0 17 16"
		>
			<path
				fill={fill}
				d="M11.274 5.57L8.496 8.712 5.72 5.57a.656.656 0 00-1.01 0 .883.883 0 000 1.142l3.286 3.717c.28.316.73.316 1.01 0l3.286-3.717a.883.883 0 000-1.142.67.67 0 00-1.017 0z"
			/>
		</svg>
	);
}

export default ChevronDownIcon;
